// src/components/ui/ConfirmModal.js
import React from 'react';
import Modal from './Modal';
import Button from './Button';
import { AlertTriangle, Trash2 } from 'lucide-react';

const ConfirmModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  message,
  title = "Confirm Action",
  isDanger = true,
  confirmText = "Confirm"
}) => {
  return (
   <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      title={<span style={{ fontSize: '11px', letterSpacing: '0.5px' }}>{title}</span>} // 🌟 NAYA: Heading ka size 11px kar diya
      icon={AlertTriangle} 
      iconColor={isDanger ? "#DC2626" : "#D97706"} 
      iconBg={isDanger ? "linear-gradient(135deg, #FEE2E2, #FCA5A5)" : "linear-gradient(135deg, #FEF3C7, #FDE68A)"}
      maxWidth="390px"
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', fontFamily: "'Plus Jakarta Sans', sans-serif", width: '100%' }}>
        <p style={{ 
          fontSize: '11px', 
          color: '#334155', 
          lineHeight: '1.6', 
          fontWeight: '700', 
          margin: 0,
          textAlign: 'center',
          textTransform: 'uppercase',
          letterSpacing: '0.3px' 
        }}>
          {message}
        </p>

        {/* Action Controls Container */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', width: '100%' }}>
          <button 
            onClick={onClose}
            style={{ 
              padding: '14px', 
              borderRadius: '16px', 
              border: '1px solid #E2E8F0', 
              background: '#F8FAFC', 
              color: '#475569', 
              fontWeight: '900', 
              fontSize: '10px', 
              textTransform: 'uppercase',
              letterSpacing: '0.5px', 
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
            className="micro-click-pill"
          >
            NO, BACK 
          </button>

          <Button 
            onClick={onConfirm} 
            icon={isDanger ? Trash2 : null}
            fullWidth={true}
            style={{ 
              padding: '14px',
              borderRadius: '16px',
              fontSize: '10px', 
              letterSpacing: '0.5px', 
              background: isDanger ? 'linear-gradient(135deg, #DC2626, #EF4444)' : 'linear-gradient(135deg, #0F172A, #1E293B)', 
              boxShadow: isDanger ? '0 8px 24px rgba(220, 38, 38, 0.25)' : '0 8px 24px rgba(15, 23, 42, 0.16)'
            }}
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;